import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Alert,
  Button,
  Chip,
  IconButton,
  Pagination,
  Stack,
  TablePagination,
  TableSortLabel,
  Typography,
} from "@mui/material";
import EuroIcon from "@mui/icons-material/Euro";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Box } from "@mui/system";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
//import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
//import ContrastOutlinedIcon from '@mui/icons-material/ContrastOutlined';
//import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const PairingRecordsChosenTable = ({ tableHeadings, rows }: Props) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const headCells = Object.entries(tableHeadings);

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };

  return (
    <>
      <Paper sx={{ mt: 0, boxShadow: "none" }}>
        <TableContainer
          className="receiptsTable"
        //  component={Paper}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headCells.map(([_, value], index) => (
                  <TableCell key={index} align="left">
                    <TableSortLabel>
                      {value && typeof value === "string" ? value : ""}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <React.Fragment key={row.cron_id}>
                    <TableRow
                      sx={{
                        "& > *": {
                          borderBottom:
                            "1px solid rgba(224, 224, 224, 1) !important",
                        },
                        background: "rgba(245, 245, 245, 1)",
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          border: "1px solid #9c27b0 !important",
                        },
                      }}
                    >
                      {headCells.map(([key], cellIndex) => (
                        <TableCell key={cellIndex} align="left">
                          {key === "company" ? (
                            <>
                              <IconButton
                                aria-label="delete"
                                size="small"
                                sx={{ mr: 1 }}
                              >
                                <CloseIcon />
                              </IconButton>
                              {row[key] || "N/A"}
                            </>
                          ) : key === "date" ? (
                            <> {row[key] ? row[key] : "N/A"}</>
                          ) : key === "receipt_number" ? (
                            <> {row[key] ? row[key] : "N/A"}</>
                          ) : key === "receipt_amount" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                {row[key] ? row[key] : "N/A"}
                                <EuroIcon
                                  sx={{
                                    color: "rgba(0, 0, 0, 0.56)",
                                    fontSize: "20px",
                                    ml: 1,
                                  }}
                                />
                              </Box>
                            </>
                          ) : key === "receipt_status" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                <div className="AlertItems">
                                  <Alert
                                    icon={
                                      <PaidOutlinedIcon
                                        fontSize="inherit"
                                        sx={{ color: "rgba(30, 70, 32, 1)" }}
                                      />
                                    }
                                    severity="success"
                                    sx={{
                                      border:
                                        "1px solid rgba(46, 125, 50, 0.5)",
                                      padding: "0px 5px",
                                      display: "inline-flex",
                                    }}
                                  >
                                    {row[key] ? row[key] : "N/A"}
                                  </Alert>

                                  {/* <Alert
                                icon={<ContrastOutlinedIcon fontSize="inherit" sx={{color:'rgba(30, 70, 32, 1)'}} />}
                                severity="success"
                                sx={{border:'1px solid rgba(46, 125, 50, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>

                               <Alert
                                icon={<PendingOutlinedIcon fontSize="inherit" sx={{color:'rgba(1, 67, 97, 1)'}} />}
                                severity="info"
                                sx={{border:'1px solid rgba(33, 150, 243, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>
                              
                               <Alert
                                icon={<RecommendOutlinedIcon fontSize="inherit" sx={{color:'rgba(1, 67, 97, 1)'}} />}
                                severity="info"
                                sx={{border:'1px solid rgba(33, 150, 243, 0.5)',padding:'0px 5px',display:'inline-flex'}}
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Alert>*/}
                                </div>
                                <select className="ChangeStatus">
                                  <option>Collected</option>
                                  <option>Partially Collected</option>
                                  <option>Approved For Invoice</option>
                                  <option>Final</option>
                                  <option>Invoice Collected</option>
                                  <option>Dispute</option>
                                </select>
                              </Box>
                            </>
                          ) : key === "fme" ? (
                            <div className="chip-data">
                              <>
                                {Array.isArray(row[key]) &&
                                row[key].length > 0 ? (
                                  <>
                                    {/* Show Chips when array has values */}
                                    {row[key].map((item, index) => (
                                      <Chip
                                        key={index}
                                        label={item}
                                        sx={{
                                          backgroundColor: "#ffffff",
                                          color: "rgba(0, 0, 0, 0.87)",
                                          borderRadius: "5px",
                                          boxShadow:
                                            "1px 1px 2px 1px #00000030",
                                          height: "26px",
                                          fontWeight: "500",
                                          cursor: "pointer",
                                          border: "1px solid #ffffff",
                                          marginRight: "6px",
                                          "&:hover": {
                                            backgroundColor: "transparent",
                                            color: "#9c27b0",
                                            border: "1px solid #9c27b0",
                                          },
                                        }}
                                        onClick={handleClick}
                                        onDelete={() => handleDelete()}
                                        deleteIcon={
                                          <CloseIcon
                                            sx={{
                                              color: "#9c27b0 !important",
                                              fontSize: "16px !important",
                                            }}
                                          />
                                        }
                                      />
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {/* If array empty → show ONLY button */}
                                    <Button
                                      color="inherit"
                                      size="small"
                                      startIcon={<AddIcon />}
                                    >
                                      Click to add records
                                    </Button>
                                  </>
                                )}
                              </>
                            </div>
                          ) : key === "credit" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                {row[key] ? row[key] : "N/A"}{" "}
                                <CurrencyPoundIcon
                                  sx={{
                                    color: "rgba(0, 0, 0, 0.56)",
                                    fontSize: "20px",
                                    ml: 1,
                                  }}
                                />
                              </Box>
                            </>
                          ) : key === "debit" ? (
                            <>
                              <Box display={"flex"} alignItems={"center"}>
                                {row[key] ? row[key] : "N/A"}{" "}
                                <AttachMoneyIcon
                                  sx={{
                                    color: "rgba(0, 0, 0, 0.56)",
                                    fontSize: "20px",
                                    ml: 1,
                                  }}
                                />
                              </Box>
                            </>
                          ) : key === "covered" ? (
                            <>
                              <Typography
                                color={
                                  parseFloat(row[key]) > 100
                                    ? "rgba(211, 47, 47, 1)" // red
                                    : "rgba(0, 0, 0, 0.87)" // normal text color
                                }
                              >
                                {row[key] ? row[key] : "N/A"}
                              </Typography>
                            </>
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
         
        </TableContainer>
         <Stack
            spacing={1}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={rows?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                ".css-16c50h-MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
                  {
                    display: "none",
                  },
                ".MuiTablePagination-actions": {
                  display: "none",
                },
                ".MuiTablePagination-toolbar": {
                  paddingLeft: "16px",
                },
              }}
            />
            <Pagination
              count={Math.ceil(rows?.length / rowsPerPage)}
              page={page + 1}
              showFirstButton
              showLastButton
              className="pagination-button"
              color="secondary"
              size="small"
              sx={{
                ".css-wjh20t-MuiPagination-ul": {
                  justifyContent: "center",
                },
              }}
              onChange={(_, value) => handleChangePage(null, value - 1)}
            />
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              classes={{
                displayedRows: "hidden-displayed-rows", // Apply the custom class
              }}
              sx={{
                ".MuiTablePagination-actions": {
                  display: "none",
                },
                ".MuiTablePagination-input": {
                  marginRight: "15px",
                },
              }}
            />
          </Stack>
      </Paper>
    </>
  );
};

export default PairingRecordsChosenTable;
